export const DEFAULT_DASHBOARD_FILTERS = {
  dateFrom: "2025-01-01",
  dateTo: "2025-12-31",
  centerCodes: [],
};

export function normalizeCenterCode(code) {
  if (code == null) return "";
  const s = String(code).trim();
  if (/^\d+$/.test(s)) return s.length < 8 ? s.padStart(8, "0") : s;
  return s; // QA001 etc
}

export function getDashboardSearchParamPatch(searchParams) {
  const center = searchParams.get("center");
  const centers = searchParams.getAll("centerCodes");
  const from = searchParams.get("from");
  const to = searchParams.get("to");
  const normalizedCenter = normalizeCenterCode(center);
  const normalizedCenters = centers.map(normalizeCenterCode).filter(Boolean);
  const centerCodes = normalizedCenter ? [normalizedCenter] : normalizedCenters;

  if (!centerCodes.length && !from && !to) return null;

  return {
    ...(from ? { dateFrom: from } : {}),
    ...(to ? { dateTo: to } : {}),
    ...(centerCodes.length ? { centerCodes } : {}),
  };
}

export function getDashboardFiltersKey(filters) {
  return [filters.dateFrom, filters.dateTo, filters.centerCodes.join("|")].join("::");
}
